import React from 'react';
import './TeamSection.css';
import GharsaImage from '../assets/Gharsa_A.jpg';

const TeamSection: React.FC = () => {
  const teamMembers = [
    {
      name: 'Gharsa Amin',
      role: 'CEO & Founder',
      bio: 'Gharsa has 3+ years of experience in blockchain and software engineering, working with 7 startups. She’s lived in 5 countries, speaks 5 languages, and holds a Master’s in Public Administration focused on financial crime management, bringing a global perspective to complex challenges.',
      initials: 'GA',
      image: GharsaImage,
      linkedin: 'https://www.linkedin.com/in/gharsanay-amin/'
    }

  ];

  return (
    <section className="team-section">
      <div className="container">
        <div className="section-title">
          <h2>Meet Our Team</h2>
          <p>The passionate individuals driving Kavodax forward</p>
        </div>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-card-inner">
                {/* Front of card */}
                <div className="team-card-front">
                  <div className="team-image">
                    <div className="team-avatar">
                      {member.image ? (
                        <img src={member.image} alt={member.name} className="team-avatar-image" />
                      ) : (
                        <span className="team-initials">{member.initials}</span>
                      )}
                    </div>
                    <div className="team-overlay">
                      <a 
                        href={member.linkedin} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="linkedin-link"
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                  <div className="team-info">
                    <h3>{member.name}</h3>
                    <p className="team-role">{member.role}</p>
                  </div>
                </div>
                
                {/* Back of card */}
                <div className="team-card-back">
                  <div className="team-info-back">
                    <h3>{member.name}</h3>
                    <p className="team-role">{member.role}</p>
                    <p className="team-bio-full">{member.bio}</p>
                    <a 
                      href={member.linkedin} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="linkedin-link-back"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                      Connect on LinkedIn
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
